import { render, staticRenderFns } from "./configGuide.vue?vue&type=template&id=5df70993&"
import script from "./configGuide.vue?vue&type=script&lang=js&"
export * from "./configGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports